/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-07 16:24:53
 * @LastEditors: bbqin
 * @LastEditTime: 2022-06-29 15:22:56
 */
import React from 'react';

require('./index.less');

const OFFSET = {
    x: 2,
    y: 2,
};

// 获取px
function getPx(value) {
    return Math.abs(value) + 'px';
}

// get nearest parent element matching selector   origin from stackoverflow  add by bbqin
const Closest = function (el, selector) {
    if (!el) {
        return null;
    }
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if (matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
};

/**
 * 获取父级可以滚动的元素 特指y轴
 * @param {DOM} el 
 */
const getSrollParentDOM = function (el) {
    if (!el) {
        return null;
    }
    while (el) {
        if (el.style.overflowY === 'scroll' || el === document.body) {
            break;
        }
        el = el.parentElement;
    }
    return el;
}

/**
 * 设置样式
 * @param {DOM} $dom 
 * @param {Object} style 
 */
const setStyle = function ($dom, style = {}) {
    for (const key in style) {
        if (style.hasOwnProperty(key)) {
            $dom.style[key] = style[key];
        }
    }
};

const isHasClass = function ($dom, name) {
    return $dom && name && $dom.className.indexOf(name) !== -1;
};

// 添加class
const addClass = function ($dom, name) {
    !isHasClass($dom, name) && ($dom.className += ` ${name}`);
};

// 移除class
const removeClass = function ($dom, name) {
    $dom && ($dom.className = $dom.className.replace(name, ''));
};

const isDomShow = function ($dom) {
    return $dom.style.display !== 'none';
};

const mouseButton = 0; // 鼠标左键

/**
 * 已知BUG 
 * 点击checkbox时  ctrl选中难以生效 猜测 可能是checkbox 自己的选中事件和本事件出现了冲突
 */

export default class Selectable extends React.Component {
    static defaultProps = {
        unitKey: 'key', // 行关键字 rowid
        canvas: '', // 绘制区域  默认是body
        onSelect: null, // 选中回调
        selector: 'tr', // 行选择器
        response: 15, // 响应距离
        unitsData: [], // 所有行的数据
        disabled: false, // 可选值 true false 'shift' 'ctrl' 'slide'
        userSelect: false, // 启用用户文字选中
        single: false, // shif启用内置单选
    }

    constructor(props) {
        super(props);
        // 框选响应遮罩
        this.createSelectableShape();
        // 事件指定
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);

        // 当前组件的键位状态
        this.hotkey = null;

        // 鼠标初始位置的记录
        this.startPoint = {
            x: 0,
            y: 0,
        };

        // receive 的初始值
        this.receiveItem = props.startItem;
        // 记录起始行和最终行
        this.startItem = props.startItem;
        this.endItem = null;

        // 记录当前选中的数据 针对方案一
        this.selectorItem = {};
        // 或者框选的行目前有两种方案 
        // 方案一  给cavans 上的tr都注册mouseEnter  mouseLeave 事件 实时记录经过的行
        // 方案二  渲染好框之后 计算位置 落在坐标之内的行记录下来
    }

    /**
     * 创建框选遮罩
     */
    createSelectableShape() {
        let shapeCls = 'mouse-selectable-shape';
        this.$selectableShape = document.querySelector(`.${shapeCls}`);
        if (this.$selectableShape) {
            return null;
        }
        let fragment = document.createDocumentFragment();
        let $selectableShape = document.createElement('div');
        $selectableShape.className = shapeCls;
        // 合并样式
        setStyle($selectableShape, this.props.style);
        fragment.appendChild($selectableShape);
        document.body.appendChild(fragment);
        this.$selectableShape = document.querySelector(`.${shapeCls}`);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { unitsData, unitKey } = this.props;
        if (unitsData !== nextProps.unitsData) { // 假装判断了
            this.props.unitsData = nextProps.unitsData;
            // 如果没有初始位置  那么 取数据中的第一个作为初始位置
            this.startItem = !this.startItem ? nextProps.unitsData[0] && nextProps.unitsData[0][unitKey] : this.startItem;
            this.receiveItem = this.startItem;
        }
        // 如果传入的初始位置不为空  那么重新设置初始位置
        if (this.receiveItem != nextProps.startItem && nextProps.startItem) {
            this.startItem = nextProps.startItem;
            this.receiveItem = this.startItem;
        }

        this.props = { ...this.props, ...nextProps };

        let { canvas, selector, userSelect } = this.props;
        // 禁用鼠标选中 文字
        !userSelect && this.getEnabled() && addClass(this.$canvas, 'user-unselect');
    }

    componentDidMount() {
        let { canvas, selector, userSelect } = this.props;
        // 目标容器画布
        this.$canvas = document.querySelector(canvas || 'body') || document.body;
        if (!this.$canvas) {
            console.log('特殊情况，初始化时没有找到对应dom');
            return;
        }
        this.$canvas.addEventListener('mousedown', this.onMouseDown);
        this.$canvas.addEventListener('mousemove', this.onMouseMove);
        this.$canvas.addEventListener('mouseup', this.onMouseUp);
        this.$canvas.addEventListener('mouseleave', this.onMouseLeave);
        this.$canvas.addEventListener('mouseenter', this.onMouseEnter);
        // 禁用鼠标选中 文字
        !userSelect && this.getEnabled() && addClass(this.$canvas, 'user-unselect');

        let $item = this.$canvas.querySelector(selector);
        if ($item) {
            this.startItem = this.getItemkey($item);
        }
        // console.log('首项作为起始值', this.startItem);
        // this.$canvas.addEventListener('mouseover', this.onMouseOver); // 可以用于滚动的情况处理
    }

    componentWillUnmount() {

        // 清理事件 
        this.$canvas.removeEventListener('mousedown', this.onMouseDown);
        this.$canvas.removeEventListener('mousemove', this.onMouseMove);
        this.$canvas.removeEventListener('mouseup', this.onMouseUp);

        // 清理dom
        this.$canvas = null;
        this.$selectableShape = null;
    }

    /**
     * 根据关键子获取禁用状态
     * @param {String} key 
     */
    getEnabled(key) {
        let { disabled } = this.props;
        if (!key) {
            return disabled !== true;
        }
        if (key === 'ctrl') {
            return disabled !== 'ctrl';
        }
        if (key === 'shift') {
            return disabled !== 'shift';
        }
        if (key === 'slide') {
            return disabled !== 'slide';
        }
        return true;
    }

    /**
     * 获取选中项的 值
     * @param {DOM} $item 
     */
    getItemkey($item) {
        if (!$item) {
            return null;
        }
        let res = $item.className.match(/row-key-\S*/g);
        res = res && res[0] ? res[0] : '';
        return $item.getAttribute('data-row-key') || res.replace('row-key');
    }

    /**
     * 获取当前的 选中项dom
     * @param {DOM} $target 
     */
    getItem($target) {
        return Closest($target, this.props.selector);
    }

    /**
     * 获取shift 情况下选中的值
     * @param {String} startItem 
     * @param {String} endItem 
     */
    getShiftSelectData(startItem, endItem) {
        let res = {},
            count = 0,
            { unitsData, unitKey, selector } = this.props;
        if (!startItem || !endItem) {
            return {};
        }
        // 如果起点等于终点
        if (startItem === endItem) {
            return { [startItem]: startItem };
        }
        if (unitsData.length) {
            unitsData.forEach(element => {
                // 判断值是否是起点终点之间的一个
                if (element[unitKey] == startItem || element[unitKey] == endItem) { // 居然有数值型数据作为了id  所以不能使用 ===
                    count = count === 1 ? 2 : 1;
                }
                // 记录起始值以及到终点之间的路径
                if (count === 1 || count === 2) {
                    let key = element[unitKey];
                    res[key] = key;
                    // 记录终点值 终点获取之后 不再记录路径
                    count === 2 && (count = 3);
                }
            });
        } else {
            let $startItem = this.$canvas.querySelector(`[data-row-key="${startItem}"]`);
            let $endItem = this.$canvas.querySelector(`[data-row-key="${endItem}"]`);
            if (!$startItem || !$endItem) {
                return {};
            }
            let $items = this.$canvas.querySelectorAll(selector);
            $items.forEach(element => {
                // 判断值是否是起点终点之间的一个
                if (element === $startItem || element === $endItem) {
                    count = count === 1 ? 2 : 1;
                }
                // 记录起始值以及到终点之间的路径
                if (count === 1 || count === 2) {
                    let key = this.getItemkey(element);
                    res[key] = key;
                    // 记录终点值 终点获取之后 不再记录路径
                    count === 2 && (count = 3);
                }
            });
        }

        // dom操作一般比较麻烦  暂时认为所有的 子选择器都是同级元素
        return count === 3 ? res : {};
    }

    /**
     * 鼠标覆盖事件
     */
    onMouseOver = e => {
        let key = this.getItemkey(this.getItem(e.target));
        this.selectorItem[key] = true;
    }

    /**
     * 鼠标按下事件
     */
    onMouseDown = e => {
        if (e.button !== mouseButton || !this.$canvas.contains(e.target) || !this.getEnabled()) {
            return true;
        }
        // 注意顺序 
        this.clearShape();
        // 上面的方法会清空所有状态
        this.startPoint = {
            x: e.clientX,
            y: e.clientY,
        };

        console.log(this.startPoint);

        // 不同的键位判断
        if ((e.ctrlKey || e.metaKey) && e.shiftKey && this.getEnabled('ctrl') && this.getEnabled('shift')) {
            this.hotkey = 'ctrl&shift';
            // 清理数据
            this.clearData();
        } else if ((e.ctrlKey || e.metaKey) && this.getEnabled('ctrl')) { // e.metaKey 修复 mac commend 键
            this.hotkey = 'ctrl';
            let key = this.getItemkey(this.getItem(e.target));
            // 选中获取反选
            if (this.selectorItem[key]) {
                this.selectorItem[key] = false;
            } else {
                this.selectorItem[key] = true;
                this.startItem = key;
            }
        } else if (e.shiftKey && this.getEnabled('shift')) {
            this.hotkey = 'shift';
            // 清理数据
            this.clearData();
        } else {
            this.hotkey = 'down';
            // 清理数据
            this.clearData();
            // 记录一下点击时的值
            let key = this.getItemkey(this.getItem(e.target));
            this.cacheSelectorItem[key] = true;
            this.cacheStartItem = key;
            // 选中获取反选
            if (this.selectorItem[key]) {
                this.selectorItem[key] = false;
            } else {
                this.selectorItem[key] = true;
                this.startItem = key;
            }
        }
    };

    // getSrollParentDOM
    /**
     * 最后一个元素时  移动并滚动
     * @param {DOM} $last 
     */
    moveToScroll($last, reverse) {
        if (!$last) {
            return;
        }
        let $scroll = getSrollParentDOM($last),
            sh = $scroll.offsetHeight,
            step = $last.offsetHeight,
            lt = $last.getBoundingClientRect().top,
            st = $scroll.getBoundingClientRect().top;
        if (reverse && (step * 2 > lt - st)) {
            $scroll.scrollTop -= step;
            return;
        }
        if (step * 2 > sh + st - lt) { // 剩余接近两行时
            $scroll.scrollTop += step;
        }
    }

    /**
     * 鼠标区域内移动事件
     */
    onMouseMove = e => {
        let { response } = this.props;
        // 禁用了
        if (!this.getEnabled('slide')) {
            return false;
        }

        if (e.button == mouseButton && this.hotkey) {
            // 初始位置
            let X = this.startPoint.x,
                Y = this.startPoint.y,
                // 当前视口
                clientX = e.clientX,
                clientY = e.clientY,
                // 当前页面
                pageX = e.pageX,
                pageY = e.pageY,
                // 滚动条偏移量
                offsetY = pageY - clientY,
                offsetX = pageX - clientX,
                // width = document.body.clientWidth,
                // height = document.body.clientHeight,
                // 应该用窗口高度
                width = window.innerWidth,
                height = window.innerHeight,
                style = this.$selectableShape.style;
            // 如果响应距离不够或者  响应遮罩未显示 就不进行遮罩的选择  以及是否是可用的功能
            if (Math.abs(clientY - Y) < response) {
                return false;
            }
            addClass(this.$canvas, 'pointer-events-none');
            this.hotkey = 'slide';
            let key = this.getItemkey(this.getItem(e.target));
            this.selectorItem[key] = true;
            // 通过响应距离之后就可以把缓存数据放到 对象里了
            this.selectorItem = { ...this.selectorItem, ...this.cacheSelectorItem };
            this.startItem = this.cacheStartItem;

            // 位置计算
            style.right = 'auto';
            style.bottom = 'auto';
            // 框框的绘制
            if (clientX >= X && clientY >= Y) {
                style.top = getPx(offsetY + Y - OFFSET.y);
                style.left = getPx(offsetX + X - OFFSET.x);
            } else if (clientX < X && clientY >= Y) {
                style.top = getPx(offsetY + Y - OFFSET.y);
                style.left = getPx(offsetX + clientX + OFFSET.x);
            } else if (clientX >= X && clientY < Y) {
                style.top = getPx(offsetY + clientY + OFFSET.y);
                style.left = getPx(offsetX + X - OFFSET.x);
            } else {
                style.top = getPx(offsetY + clientY + OFFSET.y);
                style.left = getPx(offsetX + clientX + OFFSET.x);
            }

            // 初始化宽度
            style.width = getPx(clientX - OFFSET.x - X);
            style.height = getPx(clientY - OFFSET.y - Y);

            // 滚动框选
            this.moveToScroll(e.target, clientY < Y);
        }
    };

    /**
     * 鼠标离开区域事件
     */
    onMouseLeave = e => {
        if (e.button === mouseButton) {
            this.clearShape();
            this.hotkey = null;
        }
    };

    /**
     * 鼠标进入开区域事件
     */
    onMouseEnter = e => {
        if (e.button === mouseButton) {
            this.clearShape();
            this.hotkey = null;
        }
    };

    /**
     * 鼠标弹起事件
     */
    onMouseUp = e => {
        let { onSelect, response, single } = this.props;
        if (e.button !== mouseButton || !this.hotkey) {
            return;
        } else {
            this.endItem = this.getItemkey(this.getItem(e.target));
            switch (this.hotkey) {
                case 'ctrl':
                    break;
                case 'ctrl&shift':
                case 'shift':
                    this.selectorItem = Object.assign({}, this.selectorItem, this.getShiftSelectData(this.startItem, this.endItem));
                    break;
                case 'slide':
                    let startY = this.startPoint.y,
                        endY = e.clientY;
                    if (Math.abs(endY - startY) < response) {
                        return;
                    }
                    // 如果Y轴方向不同会调换初始值
                    if (endY - startY < 0) {
                        this.startItem = this.endItem;
                    }
                    this.clearShape();
                    break;
                default:

                    break;
            }
            // 清理一下无效数据
            delete this.selectorItem[null];
            // console.log(this.selectorItem);

            // down的情况 由外部的rowClick来进行处理 否则就需要去除外部的逻辑
            if (this.hotkey && this.hotkey !== 'down') {
                onSelect && onSelect(this.selectorItem, this.hotkey, { currentKey: this.endItem, e }); // 回调中给出操作类型
            }
            if (this.hotkey && this.hotkey === 'down' && single) {
                onSelect && onSelect(this.selectorItem, this.hotkey, { currentKey: this.endItem, e });
            }
            this.hotkey = null;
        }

    };

    /**
     * 清理数据
     */
    clearData() {
        // 记录当前选中的数据 针对方案一
        this.selectorItem = {};
    }

    /**
     * 主要给框选用
     * 清理框选遮罩样式
     */
    clearShape() {
        removeClass(this.$canvas, 'pointer-events-none');
        if (this.$selectableShape) {
            this.$selectableShape.style.width = '0';
            this.$selectableShape.style.height = '0';
            this.$selectableShape.style.top = 'auto';
            this.$selectableShape.style.right = 'auto';
            this.$selectableShape.style.bottom = 'auto';
            this.$selectableShape.style.left = 'auto';
            this.$selectableShape.style.display = 'block';
            this.$selectableShape.style.border = 'none';
        }

        // 清除初始位置
        this.startPoint = {
            x: 0,
            y: 0,
        };
        // 清理keydown时缓存的键值
        this.cacheSelectorItem = {};
        this.cacheStartItem = this.startItem;
    }

    render() {
        return null;
    }
}
